import { useFeatureValue } from '@growthbook/growthbook-react';
import React, { useEffect } from 'react'
import { loadScript } from './utils/loadScript';

const DEFAULT_CONFIG = {
    enabled: false,
    scriptUrl: "",
  };

export const useJsCramblerScript = () => {
    const config = useFeatureValue( "core.security.jscrambler.config", DEFAULT_CONFIG);

    const jsCramblerScriptLoad = (url:string) => {
      const scriptsArgs = { src: url, onload: () => console.log("jscrambler script loaded", url), async: true};
      loadScript(scriptsArgs);
    }

    useEffect(() => {
      if(config.enabled) jsCramblerScriptLoad(config.scriptUrl)
    }, [config.enabled]);
    
  return null
}
